// extracted by mini-css-extract-plugin
export default {"main":"home_main__V-EMM"};